import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { SORTED_QUESTION } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { SortedAnswersData, SortedQuestionDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadSortedQuestion =
  (
    id: number,
    data: SortedAnswersData,
  ): ThunkAction<Promise<void>, State, null, SortedQuestionDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: SORTED_QUESTION + REQUEST });
    try {
      const payload = await api.loadSortedQuestion(id, data);
      dispatch({ type: SORTED_QUESTION + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: SORTED_QUESTION + FAILURE, error });
    }
  };

export const sortedQuestionIdle = () => ({ type: SORTED_QUESTION + IDLE });
